import { FormEvent, useRef, useState } from "react";

import {
  add_nium_fund_wallet,
  get_xflow_balance,
  get_xflow_vban_address,
} from "../../constants/apis";
import InputWithLabel from "../../components/InputWithLabel";
import CrossIcon from "../../components/Icons/CrossIcon";

import { useAppContext } from "../../context/AppContext";
import USAFlag from "../../assets/img/USA-flag.png";
import Chart2 from "../../assets/img/chart2.png";
// import AddIcon from "../Icons/AddIcon";
import { useWalletFundContext } from "../../context/WalletFundContext";
import SpinnerIcon from "../Icons/SpinnerIcon";
import { toast } from "react-toastify";
import { useFetch } from "../../hooks/useFetch";
import { Balance, VBANRes } from "../../types/XFlow";

export default function XFlowVbanCard() {
  const { jwtToken } = useAppContext();

  const { data, loading } = useFetch<Balance>(
    get_xflow_balance,
    {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "content-type": "application/json",
      },
    },
    jwtToken!
  );

  // const walletData = data?.available?.find((el) => el.currency === "USD");
  const walletData = data?.pending?.find((el) => el.currency === "USD");

  return (
    <div id="xflow-vban-card" className="flip-card card h-[146px] !bg-custom-dark-blue-new text-white !rounded-2xl !border !border-blue-100/70">
      {loading ? (
        <div className="animate-pulse ">
          <div className="space-y-6 py-1">
            <div className="h-4 w-[60%] bg-slate-300 rounded"></div>
            <div className="space-y-3">
              <div className="h-8 bg-slate-300 rounded"></div>
              <div className="h-2 w-[40%] bg-slate-300 rounded"></div>
            </div>
          </div>
        </div>
      ) : (
        <div className="flip-card-inner relative w-full h-full ">
          <div className="flip-card-front">
            <div className="flex items-center justify-between mb-2">
              <h2 className="font-semibold text-lg">
                {walletData?.currency || "USD"} - Account
              </h2>
              <img src={USAFlag} alt="usa flag" />
            </div>

            <div className="flex justify-between items-center">
              <div>
                <p>
                  <span className="font-bold text-3xl">
                    {walletData?.amount || "0.00"}
                  </span>{" "}
                  <span className="font-medium text-xs text-white">
                    {/* / This Month */}/ Month
                  </span>
                </p>
                <small className="text-white">100.00.last month</small>
              </div>

              <div>
                <img src={Chart2} alt="chart" />
              </div>
            </div>
          </div>
          <WalletCardFlip />
        </div>
      )}
    </div>
  );
}

function WalletCardFlip() {
  const [btnLoading, setBtnLoading] = useState(false);
  const addWalletBalanceModalRef = useRef<HTMLDialogElement>(null);
  const copyContainerRef = useRef<HTMLDivElement>(null);

  const { jwtToken } = useAppContext();
  const { refetch } = useWalletFundContext();

  const { data, loading } = useFetch<VBANRes>(
    get_xflow_vban_address,
    {
      headers: {
        Authorization: `Bearer ${jwtToken}`,
        "content-type": "application/json",
      },
    },
    jwtToken!
  );

  // console.log(data);

  const virtualBankData = data?.data?.at(0);

  const handleCopyVBan = () => {
    if (copyContainerRef.current) {
      const paras = copyContainerRef.current.querySelectorAll("p");
      const text = Array.from(paras)
        .map((p) => p.innerText)
        .join("\n\n");

      navigator.clipboard.writeText(text).then(() => {
        toast.success("Copied to clipboard!");
      });
    }
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setBtnLoading(true);

    const formData = new FormData(e.currentTarget);
    const amount = formData.get("amount");

    const paylaod = {
      amount,
      destinationCurrencyCode: "USD",
      fundingChannel: "PREFUND",
      sourceCurrencyCode: "USD",
    };

    try {
      const res = await fetch(add_nium_fund_wallet, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          "content-type": "application/json",
        },
        body: JSON.stringify(paylaod),
      });
      const data = await res.json();

      console.log(data);

      if (data?.status === "success") {
        refetch();
        addWalletBalanceModalRef.current?.close();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setBtnLoading(false);
    }
  };

  return (
    <>
      <div className="flip-card-back ">
        <h3 className="font-medium flex justify-between items-center">
          Account Details:{" "}
          {/* <button
            className="flex items-center gap-1 text-custom-dark-blue hover:underline"
            onClick={addBalanceModal}
          >
            <AddIcon className="size-4" /> add balance
          </button> */}
          {virtualBankData?.status === "activated" && (
            <button
              className="flex items-center gap-1 border border-b-gray-50 px-3 mt-[-2px] text-white rounded-md text-xs hover:scale-95"
              onClick={handleCopyVBan}
            >
              Copy
            </button>
          )}
        </h3>
        {loading ? (
          <div className="animate-pulse">
            <div className="space-y-3 py-1">
              <div className="h-2 w-[60%] bg-slate-300 rounded"></div>
              <div className="h-2 bg-slate-300 rounded"></div>
              <div className="h-2 bg-slate-300 rounded"></div>
              <div className="h-2 w-[40%] bg-slate-300 rounded"></div>
            </div>
          </div>
        ) : virtualBankData?.status !== "activated" || !data ? (
          <div>
            <p className="text-gray-500 text-sm text-center mt-4">
              Account status is not active yet
            </p>
          </div>
        ) : (
          <div ref={copyContainerRef}>
            <p className="text-[12px] flex justify-between">
              <span>Account No.:</span>{" "}
              <span className="text-white">
                {virtualBankData?.bank_account.number}{" "}
                {`(${virtualBankData?.currency})`}
              </span>
            </p>
            <p className="text-[12px] flex justify-between">
              <span>Bank Name:</span>{" "}
              <span className="text-white">
                {virtualBankData?.bank_account.bank_name}
              </span>
            </p>
            <p className="text-[12px] flex justify-between">
              <span>ACH:</span>{" "}
              <span className="text-white">{`${virtualBankData?.bank_account.domestic_credit}`}</span>
            </p>

            <p className="text-[12px] flex justify-between">
              <span>Domestic Wire:</span>{" "}
              <span className="text-white">{`${virtualBankData?.bank_account.domestic_wire}`}</span>
            </p>
            <p className="text-[12px] flex justify-between">
              <span>Global Wire:</span>{" "}
              <span className="text-white">{`${virtualBankData?.bank_account.global_wire}`}</span>
            </p>
            {/* <p className="text-[12px] flex justify-between">
              <span>Currency:</span>
              <span className="text-white">
                {virtualBankData?.currency}
              </span>
            </p> */}
          </div>
        )}
      </div>

      <dialog
        ref={addWalletBalanceModalRef}
        className="p-6 w-[400px] space-y-4 rounded-md backdrop:bg-black/50"
      >
        <div>
          <button
            className="float-end"
            onClick={() => addWalletBalanceModalRef.current?.close()}
          >
            <CrossIcon className="size-6" />
          </button>

          <h2 className="text-xl font-bold text-gray-800">
            Add Wallet Balance
          </h2>
          <p className="text-sm text-gray-500">
            Lorem ipsum dolor sit amet consectetur adipisicing elit.
          </p>
        </div>

        <form onSubmit={handleSubmit}>
          <InputWithLabel
            label="Amount"
            placeholder="Enter a amount"
            name="amount"
            type="number"
            required
          />
          <button
            className="w-full h-[44px] rounded-md bg-custom-blue-medium text-white font-medium"
            disabled={btnLoading}
          >
            {btnLoading ? (
              <SpinnerIcon className="size-4 text-gray-200 animate-spin fill-blue-600 inline-flex justify-center" />
            ) : (
              "Add"
            )}
          </button>
        </form>
      </dialog>
    </>
  );
}
